/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC, ReactElement } from 'react'
import ReactLoading from 'react-loading'
import { Container, ContainerOutsideProps } from './styles'

type ButtonProps = {
  children: ReactElement | string | null;
  size?: 'lg' | 'md' | 'sm';
  variant?: 'primary' | 'white' | 'link' | 'muted' | 'danger';
  block?: boolean;
  isLoading?: boolean;
  onClick?: (e: any) => void;
}

type ButtonPropsAcc = ButtonProps & ContainerOutsideProps;

const Button: FC<ButtonPropsAcc> = ({
  onClick,
  isLoading,
  children,
  size,
  variant,
  block,
  ...restProps
}): ReactElement => {
  return (
    <Container
      className='button'
      disabled={isLoading}
      onClick={isLoading ? undefined : onClick}
      block={block}
      size={size}
      variant={variant}
      {...restProps}
    >
      {isLoading
        ? <ReactLoading className='spinner' type='spin' color='#000' height={17} width={17} />
        : children}
    </Container>
  )
}

Button.defaultProps = {
  size: 'md',
  variant: 'primary'
}

export default Button
